import React from "react";

export const FbaseAuthUserContext = React.createContext(null);
